import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private count = signal(0);
  loading = computed(() => this.count() > 0);
  show() {
    this.count.update((v) => v + 1);
  }

  hide() {

    this.count.update((v) => Math.max(this.count() - 1, 0));
  }
}
